import { Link } from 'react-router-dom';
import { Row, Col, Container, Spinner } from 'reactstrap';

// Every dashboard the app embeds from Jitto Answer, in place of ThoughtSpot's
// custom dashboards list (features/dashboards/jittoEmbed jittoDashboardList).
// No heading of its own: it sits under the asset class's Dashboards title.
export default (props) => {
    const {dashboards, status} = props;
    const loading = status == 'loading';
    return (
        <Container>
            <Row className='mt-4 mb-5'>
                <Col className='pl-3'>
                    {loading ? <><Spinner /> Loading...</> : (
                        <Container className="w-full">
                            <Row className='header-row'>
                                <Col className='m-2'>Name</Col>
                                <Col className='m-2'>Asset class</Col>
                            </Row>
                            {
                                dashboards.map((d,i) => (
                                    <Link to={`/dashboard/${d.id}`} key={d.id}>
                                        <Row className={`grid-row ${(i%2 ? 'odd-row' : 'even-row')}`}>
                                            <Col className='m-2'>{d.name}</Col>
                                            <Col className='m-2'>{d.assetClass}</Col>
                                        </Row>
                                    </Link>
                                ))
                            }
                        </Container>
                    )}
                    {(dashboards == null || dashboards.length == 0) && !loading && <p>No dashboards to display.</p>}
                </Col>
            </Row>
        </Container>
    )
}
